import { TextInput } from '@pandiafi/design-system'
import { Field, FieldProps } from 'formik'
import { t } from 'i18next'
import React from 'react'

import FormFieldWrapper from 'components/FormField'

type Props = {
  required: boolean
}

export const PostalCodeField: React.FC<Props> = ({ required }) => {
  return (
    <Field name="newAddress.postalCode">
      {({ field, meta }: FieldProps) => (
        <FormFieldWrapper
          name={field.name}
          label={t('terminateContract:labels.postalCode')}
          className="min-tablet:mb-4"
          meta={meta}
          labelBold
          required={required}
        >
          <TextInput {...field} className="w-1/2" />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
